export {default as dispatch} from "./dispatch.js";



//////////////////
// WEBPACK FOOTER
// ./~/d3-dispatch/src/index.js
// module id = 36
// module chunks = 0